import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DeeprootsLogsService } from '../../services/deeproots-logs.service';
import { DeeprootsLinkSubmissionLog } from '../../models/deeproots-log';
import {
  TableColumn,
  TableComponent,
} from '../../../../../shared/components/table/table.component';
import { takeUntil } from 'rxjs';
import { PageSizeComponent } from '../../../../../shared/components/page-size/page-size.component';
import { PaginationComponent } from '../../../../../shared/components/pagination/pagination.component';
import { SearchInputComponent } from '../../../../../shared/components/search-input/search-input.component';
import { Router } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { MenuComponentBase } from '../../../../../shared/base-classes/menu-component-base';

@Component({
  selector: 'app-deeproots-links',
  standalone: true,
  imports: [
    CommonModule,
    TableComponent,
    PageSizeComponent,
    PaginationComponent,
    SearchInputComponent,
    FormsModule,
  ],
  templateUrl: './deeproots-links.component.html',
  styleUrl: './deeproots-links.component.scss',
})
export class DeeprootsLinksComponent
  extends MenuComponentBase
  implements OnInit
{
  deeprootsLogsService = inject(DeeprootsLogsService);
  router = inject(Router);

  loading = true;
  logs: DeeprootsLinkSubmissionLog[] = [];
  currentPage = 1;
  pageSize = 50;
  totalLogs = 0;
  searchText = '';

  tableColumns: TableColumn[] = [
    { header: 'CDFI', width: '70%' },
    { header: 'Submissions', width: '20%' },
    { header: 'View', width: '10%' },
  ];

  override ngOnInit(): void {
    super.ngOnInit();
    this.route.queryParams
      .pipe(takeUntil(this.destroy$))
      .subscribe((params) => {
        this.searchText = params['search'] || '';
        this.loadLogs(this.currentPage, this.pageSize);
      });
  }

  loadLogs(page: number, pageSize: number): void {
    this.loading = true;
    this.deeprootsLogsService
      .getDeeprootsLinkSubmissionLogs(page, pageSize, this.searchText)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res) => {
          this.logs = res.results;
          this.totalLogs = res.count;
          this.loading = false;
        },
        error: () => {
          this.loading = false;
        },
      });
  }

  onPageChange(page: number): void {
    this.currentPage = page;
    this.loadLogs(this.currentPage, this.pageSize);
  }

  onPageSizeChange(newPageSize: number): void {
    this.pageSize = newPageSize;
    this.currentPage = 1;
    this.loadLogs(this.currentPage, this.pageSize);
  }

  onSearchQueryChange(query?: string): void {
    if (query !== undefined) {
      this.searchText = query;
      this.router.navigate([], {
        queryParams: { search: this.searchText || null },
        queryParamsHandling: 'merge',
      });
      this.currentPage = 1;
      this.loadLogs(this.currentPage, this.pageSize);
    }
  }

  viewDetails(log: DeeprootsLinkSubmissionLog) {
    this.router.navigate(['/leads/find'], {
      queryParams: {
        tab: 'deeproots',
        subtab: 'inquiries',
        created_by_org: log.id,
        submitted_by_link_or_qr: 'true',
      },
      queryParamsHandling: 'merge',
    });
  }
}
